import { render, staticRenderFns } from "./ShareOnes.vue?vue&type=template&id=05cd78db&scoped=true"
import script from "./ShareOnes.vue?vue&type=script&lang=js"
export * from "./ShareOnes.vue?vue&type=script&lang=js"
import style0 from "./ShareOnes.vue?vue&type=style&index=0&id=05cd78db&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05cd78db",
  null
  
)

export default component.exports